import React from 'react';
import { View, Text } from 'react-native';
import { gql, useQuery } from '@apollo/client';
import DataTable from '@preflighttech/preflight-tables';
import moment from 'moment';

import formattedLocation from 'app/src/components/Assets/formattedLocation';
import { BID_CORE_FIELDS } from 'app/src/components/Bidding/queries';
import { BUYER_CORE_FIELDS } from 'app/src/components/Buyers/queries';
import DataState from 'app/src/components/DataState';
import minimalTable from 'app/src/elements/minimalTable';
import { dollars } from 'app/src/utils/stringHelpers';
import { Link } from 'app/src/utils/routing';

const SALE_ASSET_BIDS = gql`
  ${BID_CORE_FIELDS}
  query SaleAssetBids($id: ID!) {
    saleAsset(id: $id) {
      bids {
        ...BidCoreFields
        buyerUser {
          id
          fullName
        }
        buyer {
          ${BUYER_CORE_FIELDS}
        }
      }
    }
  }
`;

const columns = [
  {
    key: 'createdAt',
    label: 'Time',
    sort: 'prevent',
    width: 200,
    content: ({ value }) => moment(value).format('MM-DD-YY \@ hh:mm:ss A')
  },
  {
    key: 'price',
    label: 'Price',
    sort: 'prevent',
    width: 100,
    content: ({ value }) => dollars(value),
  },
  {
    key: 'buyerUser',
    label: 'Buyer',
    sort: 'prevent',
    width: 200,
    value: ({ entry }) => (entry.buyerUser?.fullName || 'Unknown - Floor Bid'),
    content: ({ entry, value }) => (
      entry.buyer ?
        <Link to={`/buyers/${entry.buyer.id}`}>{value}</Link> :
        <Text>{value}</Text>
    )
  },
  {
    key: 'paddleNumber',
    label: 'Paddle #',
    sort: 'prevent',
    width: 100,
  },
  {
    key: 'buyer',
    label: 'Buyer Contact',
    sort: 'prevent',
    width: 400,
    value: ({ value }) => (
      value ? (
        [
          (value.companyName && value.name ? value.companyName : null),
          formattedLocation(value),
          value.email,
          value.phoneNumber?.formatted
        ].filter(detail => detail).join(' | ')
      ) : ''
    )
  }
];

const PaddleServiceBids = ({ saleAsset }) => {
  const { data } = useQuery(SALE_ASSET_BIDS, {
    variables: { id: saleAsset.id }
  });

  if (!data) { return <DataState.Loading />; }

  const bids = data.saleAsset.bids.toReversed();

  if (0 === bids.length) {
    return (
      <Text>
        There were no bids made for this asset via the ELAG paddle service
      </Text>
    );
  }

  return (
    <View style={{minWidth: 1000}}>
      <DataTable.Simple
        data={bids}
        columns={columns}
        component={minimalTable}
        pageLength="All"
        htmlTable
      />
    </View>
  );
};

export default PaddleServiceBids;
